import { RootState } from "../root.reducer";

export const searchFormSelector = (state: RootState) => state.searchForm;
